<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="管理账号">
              <el-input clearable v-model.trim="where.username" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="手机号码">
              <el-input clearable v-model.trim="where.mobile" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="电子邮箱">
              <el-input clearable v-model.trim="where.email" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button @click="openEdit(null)" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
            v-if="permission.includes('sys:admin:add')">添加</el-button>
          <el-button :disabled="!selection.length" @click="removeBatch" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
            v-if="permission.includes('sys:admin:dall')">删除</el-button>
        </template>
        <template slot="roles" slot-scope="{ row }">
          <el-tag v-for="item in row.roles" :key="item.id" size="mini" type="primary" :disable-transitions="true">
            {{ item.name }}
          </el-tag>
        </template>
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"
            v-if="permission.includes('sys:admin:status')" />
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:admin:edit')">编辑</el-button>
          <el-button size="small" type="warning" class="ele-btn-icon" @click="openBind(row)"
            v-if="permission.includes('sys:admin:edit')">绑定</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此管理员吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:admin:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
          <el-popconfirm class="ele-action" title="确定要重置密码吗？" @confirm="resetPwd(row)"
            v-if="permission.includes('sys:admin:edit')">
              <el-button size="small" type="success" class="ele-btn-icon" slot="reference">重置</el-button>
            </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <user-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <admin-bind-dialog :admin="bindRow" :visible.sync="showBind" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserEdit from "./user-edit";
import AdminBindDialog from "./admin-bind-dialog";

export default {
  name: "SystemAdmin",
  components: { UserEdit, AdminBindDialog },
  computed: {
    ...mapGetters(["permission"]),
  },
  data() {
    return {
      url: "/admin/index",
      columns: [
        { columnKey: "selection", type: "selection", width: 45, align: "center", fixed: "left" },
        { prop: "id", label: "序号", width: 60, align: "center", fixed: "left" },
        { prop: "username", label: "账号", minWidth: 100, align: "center" },
        { prop: "bot_group_name", label: "绑定群组", minWidth: 120, align: "center", showOverflowTooltip: true },
        { prop: "mobile", label: "手机", minWidth: 100, align: "center" },
        { prop: "email", label: "邮箱", minWidth: 110, align: "center" },
        { columnKey: "roles", label: "角色", minWidth: 100, align: "center", slot: "roles" },
        { prop: "status", label: "状态", width: 100, align: "center", slot: "status" },
        {
          prop: "create_time", label: "创建时间", minWidth: 100, align: "center",
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        { columnKey: "action", label: "操作", width: 340, align: "center", slot: "action", fixed: "right" },
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      bindRow: null,
      showBind: false,
    };
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    openBind(row) {
      this.bindRow = row;
      this.showBind = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post("/admin/delete", { id: row.id }).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error("请选择");
        return;
      }
      this.$confirm("确定要删除选中的管理员吗?", "提示", { type: "warning" }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post("/admin/delete", { id: this.selection.map(d => d.id) }).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post("/admin/status", { id: row.id, status: row.status }).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    resetPwd(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post("/admin/resetPwd", { id: row.id }).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
  },
};
</script>
